import {combineReducers} from "@reduxjs/toolkit";
import {Action, GraphqlQueryAction, setBackendError} from "./actions";
import {BackendError, Notification} from "./types";

const emptyNotification: Notification = {
    show: false,
    message: {id: "", defaultMessage: ""},
    variant: "success",
    messageVars: {},
    autoHideDuration: 5000,
};

function notification(state: Notification = emptyNotification, action: any): Notification {
    switch (action.type) {
        case Action.SHOW_NOTIFICATION:
            return {
                message: action.message,
                variant: action.variant,
                show: true,
                messageVars: action.vars,
                autoHideDuration: action.autoHideDuration,
            } as Notification;
        case Action.HIDE_NOTIFICATION:
            return Object.assign({}, state, {show: false});
        default:
            return state;
    }
}

function backendError(state: BackendError = null, action: ReturnType<typeof setBackendError>): BackendError {
    if (action.type === Action.SET_BACKEND_ERROR) {
        return action.error;
    }

    return state;
}

function graphqlQueryIds(state: string[] = [], action: GraphqlQueryAction) {
    if (action.type === Action.GQL_QUERY_REQUEST) return [...state, action.id];

    if (action.type === Action.GQL_QUERY_RESPONSE) {
        // Using filter to create a new array instead of mutating with splice
        return state.filter((id) => id !== action.id);
    }

    return state;
}

const rootReducer = combineReducers({
    notification,
    backendError,
    graphqlQueryIds,
});

export default rootReducer;
